import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const strengths = [
  {
    icon: 'ri-book-open-line',
    title: '創業時から妥協しない教育体制',
    desc: '業歴に関係なく、品質は最初から最高水準で。入社後の研修プログラム・OJT・定期スキルアップを軸に、現場レベルを一切落とさない育成体制を整えています。',
    tags: ['定期研修', 'OJT制度', 'マニュアル完備'],
  },
  {
    icon: 'ri-medal-2-line',
    title: '資格取得を会社全力バックアップ',
    desc: 'スタッフ全員の警備業務検定取得を目標に、受験費用の会社負担・勉強時間の確保など全力で支援。資格者を増やしながら、対応できる現場の幅を着実に広げています。',
    tags: ['受験費用サポート', '資格取得推進中', '対応範囲を拡大中'],
  },
  {
    icon: 'ri-rocket-2-line',
    title: 'スピードと即応力が武器',
    desc: '新しい組織だからこそ、動きが速い。緊急案件への即日対応・急な増員依頼にも柔軟に対応できる体制が、リピート依頼と口コミ拡大につながっています。',
    tags: ['緊急案件OK', '即日手配可', '柔軟な増員対応'],
  },
];

export default function Strengths() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="strengths" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div ref={ref} className={`fade-in-up ${isVisible ? 'visible' : ''}`}>
          <div className="text-center mb-16">
            <span className="text-[#38BDF8] text-sm font-medium tracking-widest">WHY CHOOSE US</span>
            <h2 className="text-[#0D1A4E] text-3xl md:text-4xl font-black mt-3 mb-4">
              私たちが選ばれる理由
            </h2>
            <div className="w-12 h-1 bg-[#38BDF8] mx-auto"></div>
            <p className="text-gray-500 mt-6 max-w-xl mx-auto text-sm leading-relaxed">
              設立2年、まだ歴史は浅い。それでも、品質と対応力に徹底してこだわり続けた結果、<br />
              依頼件数は急拡大。成長が止まらない私たちの「選ばれる理由」があります。
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {strengths.map((item, idx) => (
              <div
                key={idx}
                className={`fade-in-up ${isVisible ? 'visible' : ''} border border-gray-100 rounded-lg p-8 bg-white hover:border-[#38BDF8]/40 transition-colors duration-300`}
                style={{ transitionDelay: `${idx * 0.15}s` }}
              >
                <div className="w-14 h-14 flex items-center justify-center bg-[#38BDF8]/10 rounded-lg mb-6">
                  <i className={`${item.icon} text-[#38BDF8] text-2xl`}></i>
                </div>
                <h3 className="text-[#0D1A4E] text-xl font-bold mb-3">{item.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-5">{item.desc}</p>
                <div className="flex flex-wrap gap-2">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="bg-[#38BDF8]/10 text-[#0D1A4E] text-xs px-2.5 py-1 rounded-full font-medium"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={`fade-in-up ${isVisible ? 'visible' : ''} mt-16 bg-[#0D1A4E] rounded-lg p-8 md:p-12`} style={{ transitionDelay: '0.5s' }}>
          <div className="grid md:grid-cols-4 gap-8 text-center">
            {[
              { num: '2年', label: '設立・急成長中' },
              { num: '200件+', label: '累計対応現場数' },
              { num: '即日', label: '緊急案件対応' },
              { num: '24時間', label: '緊急対応体制' },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="text-[#38BDF8] text-3xl font-black">{stat.num}</div>
                <div className="text-white/70 text-sm mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
